import * as swcHelpers from '@swc/helpers';
import { optional, Type } from 'specified';
import { isoDateSpec } from '../../specs-utils.js';

const addressSpec = {
    key: optional(Type.string),
    title: optional(Type.string),
    salutation: optional(Type.string),
    firstName: Type.string,
    middleName: optional(Type.string),
    affixLastName: optional(Type.string),
    lastName: Type.string,
    streetName: Type.string,
    streetNumber: optional(Type.string),
    additionalStreetInfo: optional(Type.string),
    additionalAddressInfo: optional(Type.string),
    postalCode: optional(Type.string),
    city: optional(Type.string),
    county: optional(Type.string),
    region: optional(Type.string),
    state: optional(Type.string),
    country: optional(Type.string),
    company: optional(Type.string),
    department: optional(Type.string),
    building: optional(Type.string),
    apartment: optional(Type.string),
    pOBox: optional(Type.string),
    phone: optional(Type.string),
    mobile: optional(Type.string),
    email: optional(Type.string),
    externalId: optional(Type.string),
    addressTypes: Type.array(Type.literal({
        billing: 1,
        delivery: 1,
        subscription: 1,
        'billing-online': 1,
        'delivery-online': 1,
        'billing-subscription': 1,
        'delivery-subscription': 1
    }))
};
Type.interface(addressSpec);
const addressContainerSpec = Type.interface(swcHelpers.objectSpread({}, addressSpec, {
    id: Type.string,
    createdAt: optional(isoDateSpec),
    updatedAt: optional(isoDateSpec)
}));
const addressListSpec = Type.array(addressContainerSpec);

export { addressContainerSpec, addressListSpec, addressSpec };
//# sourceMappingURL=specs.js.map
